import api from '../api';

const convertAudio = async (url) => {

    const data = {
        file: url
    }

    const res = await api.post(`/api/convertaudio/`, data, { timeout: 0 })

    if (res.status == 200)
        return res.data
    console.error('Failed to convert data.')
    return ''
}

export const getAudioFile = async (url, useNotification) => {

    const rec = await api.get(url, {
        responseType: 'blob'
    });
    // It seems that this message is reduntant, see line 72
    // if (rec.status !== 200) {
    //     useNotification(
    //         'Ops...',
    //         'O arquivo de áudio não foi encontrado.',
    //         'danger'
    //     );
    //     return false;
    // } 
    const blob = new Blob([rec.data], { type: rec.headers['content-type'] || 'audio/wav' });
    return URL.createObjectURL(blob);
}

export const playAudio = async (id, url, loading, playing, setLoading, setPlaying, useNotification, platform) => {

    if (loading)
        return

    if (playing.audio != null) {
        playing.audio.pause()
        playing.audio.currentTime = 0;
    }

    setLoading(true);
    setPlaying({ id: id, audio: null });

    try {
        const audioUrl = platform === 'INSTANTVOICE' ? await getAudioFile(url, useNotification) : url;
        let audio = new Audio(audioUrl);
        audio.onended = (() => { setPlaying({ id: null, audio: null }) })

        await audio.play();
        setPlaying({ id: id, audio: audio });
    } catch (err) {
        useNotification(
            'Aguarde!',
            'O áudio está sendo preparado.',
            'info'
        )
        try {
            const res = await convertAudio(url)
            const convertedAudioUrl = await getAudioFile(res, useNotification);
            let audio = new Audio(convertedAudioUrl);
            audio.onended = (() => { setPlaying({ id: null, audio: null }) })
            await audio.play()
            setPlaying({ id: id, audio: audio });
        }
        catch (err) {
            console.error(err)
            setPlaying({ id: null, audio: null });
            useNotification(
                'Ops...',
                'O arquivo de áudio não existe.',
                'danger'
            )
        }
    }

    setLoading(false);
}